export function ApplicationsSvg() {
    return {
        restrict: 'E',
        scope: true,
        template: `<ng-include class="d-contents" src="'../hui/modules/svg/applications.svg'"></ng-include>`
    }
}